"use client";

import RefinanceForm from "./components/refinance-form";
import { RefinanceContext } from "./types";

interface Props {
	taskId: string;
	context: RefinanceContext;
}

const RefinancingPage = ({ taskId, context }: Props) => {
	return <RefinanceForm taskId={taskId} context={context} />;
};

export default RefinancingPage;
